var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio-page"},[_c('Page-header',{attrs:{"cover":require('../assets/images/portfolio-cover.png'),"title":_vm.$t('ourPortfolio'),"desc":_vm.$t('portfolioDesc')}}),_c('Portfolio-sec')],1)}
var staticRenderFns = []

export { render, staticRenderFns }